// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_h4-2";
export var aiChatCartContainerExit = "_h4-4";
export var aiChatContainerLarge = "_h4-0";
export var aiChatContainerSmall = "_h4-1";
export var aiChatIcon = "_h4-6";
export var slideInFromRight = "_h4-3";
export var slideOutToRight = "_h4-5";